import * as React from 'react';
import { useState } from 'react';
import { ISchedule, FAKE_SCHEDULE_DATA } from '../../../../../common/constants';
import ScheduleChart from './scheduleChart';
import ScheduleTime from './Timeslot/scheduleTime';
import { Button, message } from 'antd';

interface ILightScheduleProps {
}

const LightSchedule: React.FunctionComponent<ILightScheduleProps> = (props) => {
  const [scheduleData, setScheduleData] = useState<ISchedule[]>(FAKE_SCHEDULE_DATA);

  const handleScheduleChange = (newSchedules: ISchedule[]) => {
    setScheduleData(newSchedules);
  };  

  const changeSchedule = () => {
    // Here you can also add API call to save the changes
    console.log('Schedule data updated:', scheduleData);
    message.success('Lưu thành công');
  };

  return (
    <div className="flex flex-1 flex-col lg:flex-row gap-6 px-5 max-w-7xl mx-auto overflow-scroll pb-24">
      <ScheduleChart inputData={scheduleData} />
      <ScheduleTime 
        inputData={scheduleData} 
        onScheduleChange={handleScheduleChange}
      />
      <Button className='w-[100px] mx-auto' type="primary" onClick={changeSchedule}>Lưu</Button>
    </div>
  );
};

export default LightSchedule;
